var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2501_4392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7 39.8C7.2 38.1 0 29.9 0 20C0 9 9 0 20 0C31 0 40 9 40 20C40 29.9 32.8 38.1 23.3 39.8L22.2 38.9H17.8L16.7 39.8Z",
    fill: "url(#paint0_linear_2501_4392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7998 25.5998L28.6998 19.9998H23.3998V16.0998C23.3998 14.4998 23.9998 13.2998 26.3998 13.2998H28.9998V8.1998C27.5998 7.9998 25.9998 7.7998 24.5998 7.7998C19.9998 7.7998 16.7998 10.5998 16.7998 15.5998V19.9998H11.7998V25.5998H16.7998V39.6998C17.8998 39.8998 18.9998 39.9998 20.0998 39.9998C21.1998 39.9998 22.2998 39.8998 23.3998 39.6998V25.5998H27.7998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_4392",
    x1: 20.001,
    y1: 38.6089,
    x2: 20.001,
    y2: -0.00736777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2501_4392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e63149e55c23a84a8c569f459d58a22b.svg";
export { ForwardRef as ReactComponent };